/**
 * ActivityEmptyState — Design-Final-Fix (activities.html)
 *
 * Kategorie-spezifische Empty-States (rewards, transfers, legacy),
 * generischer Fallback für 'all'.
 */
import { useTranslation } from 'react-i18next'

const EMPTY_STATE_KEYS = ['rewards', 'transfers', 'legacy'] as const
type EmptyStateKey = typeof EMPTY_STATE_KEYS[number]

type ActivityEmptyStateProps = {
  activeFilter: string | null
  /** Serverseitiges Zeitfenster in Tagen (Free/Premium-Gating); null = kein Hinweis. */
  dayLimit?: number | null
}

export function ActivityEmptyState({ activeFilter, dayLimit = null }: ActivityEmptyStateProps) {
  const { t } = useTranslation('activity')

  // Erklaert, warum "Alle" nicht wirklich die gesamte Historie zeigt.
  const hint = dayLimit ? (
    <p className="empty-state-desc muted">{t('emptyState.dayLimitHint', { days: dayLimit })}</p>
  ) : null

  if (activeFilter && (EMPTY_STATE_KEYS as readonly string[]).includes(activeFilter)) {
    const key = activeFilter as EmptyStateKey
    return (
      <div className="empty-state" role="status" aria-live="polite">
        <p className="empty-state-title">{t(`emptyState.${key}.title`)}</p>
        <p className="empty-state-desc">{t(`emptyState.${key}.description`)}</p>
        {hint}
      </div>
    )
  }

  return (
    <div className="empty-state" role="status" aria-live="polite">
      {activeFilter ? (
        <p>{t('emptyState.noCategory')}</p>
      ) : (
        <p>{t('emptyState.noActivity')}</p>
      )}
      {hint}
    </div>
  )
}
